import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { GET_Instrucation_QB } from "../../gql/queries";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { Bookmark_QB, Result_Submit } from "../../gql/mutation";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import Modal from 'react-bootstrap/Modal';
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../utils/moengageUserSetup";
export default function QbInstructions() {
    const [proUserShow, setProUser] = useState(false);
    const [qbReset, setResetQb] = useState();
    const ProUserHide = () => setProUser(false);
    const proShowUser = () => setProUser(true);
    const showResetQb = () => setResetQb(true);
    const qbHide = () => setResetQb(false);
    let { id, name } = useParams()
    const navigate = useNavigate();
    const completePathUrl = useLocation()
    const [checked, setCheck] = useState('checked');
    const [qbinterval, setqbinterval] = useState(30);
    if (checked != '') {
        localStorage.setItem("time", 30)
    }
    const time = ((data) => {
        setCheck('')
        setqbinterval(data)
        localStorage.setItem("time", data)
    });
    let subjectId = localStorage.getItem("subject")

    const resetQbPopup = () => {
        setResetQb(false);
        resultSubmit({ variables: { resultInput: { qbId: query1.data.qb._id, resultType: "Qb", startTime: "", endTime: "", duration: 0, questions: QuestionAttemptStateInput, questionInterval: 0, isCompleted: false, subjectId: query1.data.qb.subject, topicId: query1.data.qb.subjectDetail.topicId, courseName: query1.data.qb.course[0], resetQb: true } } })
    }

    const startTime = (e) => {
        let store = {
            id: id,
            name: name,
            date: query1.data?.qb?.progress?.startTime,
            time: query1.data?.qb?.progress?.questionInterval
        }
        localStorage.setItem('qbId', JSON.stringify(store));
        localStorage.setItem('start', JSON.stringify(new Date()));
        let newquestionAttempt = []
        query1.data.qb.progress != undefined && query1.data.qb.progress.questions.map((obj, i) => {
            query1.data.qb != undefined && query1.data.qb.questions.map((obj1, index) => {
                if ((obj.questionId).toString() == (obj1._id).toString()) {
                    var filteredArray
                    obj1.options.filter(function (obj2, indexes) {
                        if ((obj2._id).toString() == (obj.userAnswer).toString()) {
                            filteredArray = indexes
                        }
                    });
                    let data = {
                        "questionId": obj.questionId,
                        "answer": obj1.answer[0],
                        "userAnswer": obj.userAnswer,
                        "isReview": false,
                        "isGuessed": false,
                        "isAttempt": true,
                        "isSkipped": false,
                        "optionIndex": filteredArray
                    }
                    newquestionAttempt[i] = data
                }
            })
        })
        localStorage.setItem(id, JSON.stringify(newquestionAttempt));
    }

    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });

    const [resultSubmit] = useMutation(Result_Submit, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB, variables: {
                    "_id": id,
                }
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });

    const query1 = useQuery(GET_Instrucation_QB, {
        variables: {
            "_id": id,
        },

        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            trackEvent("viewInstruction", {
                "type": "qb", "source": "web", "content_id": id
            });
        },
    });
    useEffect(() => {
        query1.refetch()

    }, []);
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)
        }
    }

    let QuestionAttemptStateInput = []

    let bookmarklist = []
    if (query1.data && query1.data.qb.progress != null) {
        query1.data && query1.data.qb.questions.map(obj1 => {
            query1.data && query1.data.qb.progress.bookmarkedQids.map(obj => {
                if ((obj1._id).toString() == (obj).toString()) {
                    bookmarklist.push(obj1)
                    return
                }
            })
        })
    }
    const startQb = (e) => {
        let store = {
            id: query1.data.qb._id,
            name: name,
            date: new Date(),
            time: qbinterval
        }
        localStorage.setItem('qbId', JSON.stringify(store));
        localStorage.setItem('start', JSON.stringify(new Date()));
        let newquestionAttempt = []
        query1.data.qb.progress != undefined && query1.data.qb.progress.questions.map((obj, i) => {
            query1.data.qb != undefined && query1.data.qb.questions.map((obj1, index) => {
                if ((obj.questionId).toString() == (obj1._id).toString()) {
                    var filteredArray
                    obj1.options.filter(function (obj2, indexes) {
                        if ((obj2._id).toString() == (obj.userAnswer).toString()) {
                            filteredArray = indexes
                        }
                    });
                    let data = {
                        "questionId": obj.questionId,
                        "answer": obj1.answer[0],
                        "userAnswer": obj.userAnswer,
                        "isReview": false,
                        "isGuessed": false,
                        "isAttempt": true,
                        "isSkipped": false,
                        "optionIndex": filteredArray
                    }
                    newquestionAttempt[i] = data
                }
            })
        })
        localStorage.setItem(id, JSON.stringify(newquestionAttempt));
        resultSubmit({ variables: { resultInput: { qbId: query1.data.qb._id, resultType: "Qb", startTime: new Date(), endTime: "0", duration: 0, questions: newquestionAttempt, questionInterval: qbinterval, isCompleted: false, subjectId: query1.data.qb.subject, topicId: query1.data.qb.subjectDetail.topicId, courseName: query1.data.qb.course[0] } } })
    }
    // console.log(bookmarklist,"bookmarklist")
    // console.log(query1.data.qb.questions.length,query1.data.qb.progress.questions.length,"HHHHHHHHHHH")
    return (
        <>
            <div className="main_wrapper">

                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a>Home</a></li>
                        <li className="breadcrumb-item"><Link to="/qblayer">QBank</Link></li>
                        {/* <li className="breadcrumb-item"><a href="/">Anatomy</a></li> */}
                        <li className="breadcrumb-item"><Link to={`/qblayer/qblayercontent/${query1.data && query1.data.qb.parentLayerId}`}>{query1.data ? query1.data.qb.parentLayer.title : ""}</Link></li>
                        <li className="breadcrumb-item active">{query1.data ? query1.data.qb.title : ""}</li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper qbanks_wrapper qbanks_instruction_wrapper section_side_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="topics_wrapper_main">
                                <div className="subjects_wrapper topic_header">
                                    <div className="topic_header_content">
                                        <div className="topic_image_ttl d-flex align-items-baseline">
                                            {
                                                name === 'content' &&
                                                <Link to={`/qblayer/qblayercontent/${query1.data && query1.data.qb.parentLayerId}`} state={subjectId}>
                                                    <figure className="back_arrow" >
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                            }
                                            {
                                                name === 'bookmark' &&
                                                <figure className="back_arrow" onClick={() => navigate(-1)}>
                                                    <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                </figure>
                                            }
                                            {
                                                name === 'other' &&
                                                <Link to={`/qblayer/QbOtherResource/${query1.data && query1.data.qb.parentLayerId}`} state={subjectId}>
                                                    <figure className="back_arrow" >
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                            }
                                            <figure className="subject_inner_img">
                                                <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                                <span className="text_qb">QB</span>
                                            </figure>
                                            <div className="subject_ttl_detail qbanks_ttl_details">
                                                <h5>{query1.data ? query1.data.qb.title : ""}</h5>
                                                <div className="help_wrapper d-flex align-items-center">
                                                    <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{query1.data ? query1.data.qb.questions.length : 0} Questions</span></p>
                                                    {
                                                        query1.data && query1.data.qb.authorDetails &&
                                                        <p><span>Verified by</span> {query1.data.qb.authorDetails ? query1.data.qb.authorDetails.name : ""}</p>
                                                    }
                                                </div>
                                                <div className="bookmarks_share">
                                                    {
                                                        query1.data && query1.data.qb.progress == null &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.qb.progress != null && query1.data.qb.progress.isBookMarked !== true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.qb.progress != null && query1.data.qb.progress.isBookMarked === true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": false } })}>
                                                            <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {/* <span>
                                                   <img src={Icons.ShareBlue} alt="" className="img-fluid"/> Share QBank    
                                               </span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="recommended_video_wrapper instructions_wrapper">
                                    <div className="instruction_header">
                                        <h6><img src={Icons.Instructions} alt="" className="img-fluid" />Instructions</h6>
                                    </div>
                                    <div className="instructions_details">
                                        <div className="ins_list_content" dangerouslySetInnerHTML={{ __html: `${query1.data ? query1.data.qb.instruction : ""}` }}>
                                            {/* <div className="inst_counts" >
                                           <span>1</span>
                                       </div> */}
                                            {/* <div className="ins_texts" > */}
                                            {/* <p>Lörem ipsum diligt pören speling, i neng. Jaskade sydärar ditt i remalogi infrad. Fall deska gävör.</p> */}
                                            {/* </div> */}
                                        </div>
                                        {/* <ul type="none" className="instruction_list">
                                       <li>
                                           <div className="ins_list_content d-flex align-items-baseline">
                                               <div className="inst_counts">
                                                   <span>2</span>
                                               </div>
                                               <div className="ins_texts">
                                                   <p>Lörem ipsum diligt pören speling, i neng. Jaskade sydärar ditt i remalogi infrad. Fall deska gävör.</p>
                                               </div>
                                           </div>  
                                       </li>
                                       <li>
                                           <div className="ins_list_content d-flex align-items-baseline">
                                               <div className="inst_counts">
                                                   <span>3</span>
                                               </div>
                                               <div className="ins_texts">
                                                   <p>Lörem ipsum askstoppad prer operaosmos. Såhyren mikrofäsk inte jängar, det tysäv, i biodiktiga huruvida osira. Vimism dev otyn spepogt. Makromick fakakant, uktiga predesk. Vötihor autora sinysm och bengar, kasåpp anar.</p>
                                               </div>
                                           </div>  
                                       </li>
                                       <li>
                                           <div className="ins_list_content d-flex align-items-baseline">
                                               <div className="inst_counts">
                                                   <span>4</span>
                                               </div>
                                               <div className="ins_texts">
                                                   <p>Lörem ipsum askstoppad prer operaosmos. Såhyren mikrofäsk inte jängar, det tysäv, i biodiktiga huruvida osira. Vimism dev otyn spepogt. Makromick fakakant, uktiga predesk. Vötihor autora sinysm och bengar, kasåpp anar.</p>
                                               </div>
                                           </div>  
                                       </li>
                                   </ul> */}
                                    </div>
                                </div>
                                <div className="select_timer_wrapper">
                                    {
                                        query1.data && (query1.data.qb.progress == null || query1.data.qb.progress.questions.length === 0) &&
                                        <>
                                            <div className="recommended_video_wrapper instructions_wrapper time_selection_radio_btns d-flex align-items-center flex-wrap">
                                                <div className="instruction_header">
                                                    <h6><img src={Icons.HourGlass} alt="" className="img-fluid" />Customize Time</h6>
                                                </div>
                                                <div className="timer_selection d-flex align-items-center">
                                                    {checked !== '' &&
                                                        <div className="timer_1">
                                                            <input type="radio" id="radio_1" name="radioName" checked={checked} className="form-control" onKeyUp={() => time(30)} hidden />
                                                            <label htmlFor="radio_1">30 Sec</label>
                                                        </div>
                                                    }
                                                    {checked === '' &&
                                                        <div className="timer_1">
                                                            <input type="radio" id="radio_1" name="radioName" className="form-control" onClick={() => time(30)} hidden />
                                                            <label htmlFor="radio_1">30 Sec</label>
                                                        </div>
                                                    }
                                                    <div className="timer_1">
                                                        <input type="radio" id="radio_2" name="radioName" className="form-control" onClick={() => time(45)} hidden />
                                                        <label htmlFor="radio_2">45 Sec</label>
                                                    </div>
                                                    <div className="timer_1">
                                                        <input type="radio" id="radio_3" name="radioName" className="form-control" onClick={() => time(60)} hidden />
                                                        <label htmlFor="radio_3">60 Sec</label>
                                                    </div>
                                                    <div className="timer_1">
                                                        <input type="radio" id="radio_4" name="radioName" className="form-control" onClick={() => time(null)} hidden />
                                                        <label htmlFor="radio_4">Turn off</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="attempt_btn text-center">
                                                {
                                                    query1.data && query1.data.qb.purchaseStatus === 0 && ((query1.data.qb && query1.data.qb.progress === null) || (query1.data.qb.progress.questions.length === 0 || query1.data.qb && query1.data.qb.progress.isCompleted === null)) &&
                                                    <Link to={`/qblayer/qbattempt/${id}/${name}`} state={'0'}>
                                                        <button type="button" className="btn btn_theme" onClick={(e) => startQb(e)}>Attempt Now</button>
                                                    </Link>
                                                }
                                                {
                                                    query1.data && query1.data.qb.purchaseStatus !== 0 &&
                                                    <div className="attempt_btn lock_attempt text-center" onClick={proShowUser}>
                                                        <button type="button" className="btn btn_theme"><img src={Icons.Arrowfade} alt="Arrow fade" className="img-fluid" /> Attempt Now</button>


                                                    </div>
                                                }
                                            </div>
                                        </>
                                    }
                                    {
                                        query1.data && (query1.data.qb.progress != null && (query1.data.qb.progress.questions.length > 0) && (query1.data.qb.progress.questions.length < query1.data.qb.questions.length && query1.data.qb.progress.isCompleted === false) && query1.data.qb.purchaseStatus != 1 &&
                                            <div className="attempt_btn text-center" onClick={() => time(query1.data.qb.progress.questionInterval)} >
                                                <p>At Question: <span>{query1.data.qb.progress.questions.length + 1}</span></p>
                                                <Link to={`/qblayer/qbattempt/${id}/${name}`} state={query1.data.qb.progress.questions.length}>
                                                    <button type="button" className="btn btn_theme" onClick={(e) => startTime(e)} >Resume QBank</button>
                                                </Link>
                                            </div>
                                        )}

                                    {
                                        query1.data && query1.data.qb.progress != null && (query1.data && query1.data.qb.progress.questions.length === query1.data.qb.questions.length || query1.data.qb.progress.isCompleted === true) &&
                                        <>
                                            {
                                                (query1.data && query1.data.qb.purchaseStatus === 0) &&
                                                <div className="attempt_btn text-center" >
                                                    <Link to={`/qblayer/qbperformance/${query1.data.qb._id}/${name}`} >
                                                        <button type="button" className="btn btn_theme">Check Performance</button>
                                                    </Link>
                                                </div>
                                            }
                                            {
                                                query1.data && query1.data.qb.purchaseStatus !== 0 &&
                                                <div className="attempt_btn lock_attempt text-center" onClick={proShowUser}>
                                                    <button type="button" className="btn btn_theme"><img src={Icons.Arrowfade} alt="Arrow fade" className="img-fluid" /> Attempt Now</button>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>

                            </div>
                        </div>

                        <div className="col-lg-4 col-md-5 col-sm-12">
                            <div className="videos_wrapper">
                                {
                                    query1.data && query1.data.qb.progress != null && query1.data.qb.progress.questions.length > 0 &&

                                    <div className="recommended_video_wrapper reset_banks_wrapper">
                                        <div className="subjects_header" >
                                            <h6 onClick={showResetQb}><img src={Icons.Refresh} alt="Refresh" className="img-fluid" />Reset Qbank</h6>
                                        </div>
                                    </div>
                                }
                                {/* <div className="recommended_video_wrapper qbanks_bookmark_questions">
                               <div id="accordion">
                                   <div className="accrodian_card">
                                       <div className="bookmark_ttl">
                                           <a href="#collapseOne" className="card_link pos_rel" data-toggle="collapse">
                                               <div className="subjects_header">
                                                   <h6><img src={Icons.BookmarkYellow} alt="Bookmark icon" className="img-fluid"/> Bookmarked Questions <span>({bookmarklist?bookmarklist.length:0})</span></h6>
                                               </div>
                                               <span className="bookmark_arrow">
                                                   <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                               </span>
                                           </a>
                                       </div>
                                       <div className="recommend_video_details collapse show" id="collapseOne" data-parent="#accordion">
                                           <ul type="none" className="recommend_list">
                                           {bookmarklist&&bookmarklist.map((d, i) => (
                                               <li>
                                                   <div className="recommend_list_main d-flex align-items-center">
                                                       <figure className="user_img">
                                                           <span className="bookarks_qb">Q{i+1}</span>
                                                       </figure>
                                                       <div className="recommend_list_content">
                                                           <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                               <div className="continue_ttl">
                                                                   <h6>{d.question.questionText}</h6>
                                                               </div>
                                                               <div className="qbanks_rating">
                                                                   <span onClick={() => getBookmark({ variables: {  resultId:query1.data.qb.progress?query1.data.qb.progress._id:"",qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": false } })}>
                                                                       <img src={Icons.Delete} alt="Star" className="img-fluid" />
                                                                   </span>
                                                               </div>
                                                           </div>
                                                           <div className="progress_details d-flex align-items-center">
                                                               <div className="timer_progress">
                                                                   <p>{d.subjectDetail?d.subjectDetail.subjectName:""}</p>
                                                               </div>
                                                               <div className="rightArrow_icn">
                                                                   <img src={Icons.QbRightArrow} alt="Play" className="img-fluid" />
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </div>
                                               </li>
                                           ))}
                                           </ul>
                                       </div>
                                   </div>
                               </div>
                           </div> */}
                            </div>
                        </div>

                    </div>
                </section>
                {
                    (query1.data === null || query1.data.qb.length === 0) && <NoDataFound></NoDataFound>
                }

            </div>
            <Modal
                show={proUserShow}
                onHide={ProUserHide}
                backdrop="static"
                className="detail_modal report_modal proUsers_modal"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Available for only Pro users</h4>
                        <div className="cross_icon text-right">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={ProUserHide} />
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className="account_option_wrapper"> */}
                    <div className="account_header text-center">
                        <img src={Icons.LockPro} alt="" className="img-fluid" />
                        {/* <h6>Account Deleted!!</h6> */}
                        <p>This content is available for pro users only. Click on View Plans to checkout suitable plans to access this course</p>
                    </div>
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={ProUserHide}>Cancel</button>
                        <Link to={'/package/singleSubscription'} state={query1.data}>
                            <button type="submit" className="btn btn_theme">View Plans</button>
                        </Link>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={qbReset}
                onHide={qbHide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to Reset your QBank progress?</h5>
                        <p className="qb_color"><b>"Cranial nerve & columns"</b> QBank will get reset</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={qbHide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={resetQbPopup}>Reset QBank</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>

    )
}